(() => {
  const initializedComponents = new WeakSet();
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initReviews = (slider) => {
    if (initializedComponents.has(slider)) return;
    initializedComponents.add(slider); slider.dataset.alxReady = 'true';
    const slides = [...slider.querySelectorAll('[data-alx-review-slide]')];
    const dots = [...slider.querySelectorAll('[data-alx-review-dot]')];
    const pause = slider.querySelector('[data-alx-review-pause]');
    let index = 0, paused = reducedMotion() || slider.dataset.autoplay !== 'true', visible = false;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
      dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
    };
    const paintPause = () => { pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel); };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); paused = true; paintPause(); }));
    pause.addEventListener('click', () => { paused = !paused; paintPause(); });
    if (slides.length < 2) slider.querySelector('.alx-review-slider__controls').hidden = true;
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
    observer.observe(slider);
    const timer = setInterval(() => {
      if (!slider.isConnected) { clearInterval(timer); observer.disconnect(); return; }
      if (!paused && visible && !document.hidden && !slider.matches(':hover') && !slider.contains(document.activeElement)) show(index + 1);
    }, Number(slider.dataset.interval) || 6000);
    slider.addEventListener('shopify:block:select', event => { const n = slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (n >= 0) { show(n); paused = true; paintPause(); } });
    paintPause();
  };
  const run=()=>document.querySelectorAll('[data-alx-review-slider]').forEach(initReviews);document.addEventListener('shopify:section:load',run);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
